var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend2New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.72 21.6293C13.54 21.6293 11.87 20.7993 10.55 16.8293L9.83 14.6693L7.67 13.9493C3.71 12.6293 2.88 10.9593 2.88 9.77934C2.88 8.60934 3.71 6.92934 7.67 5.59934L16.16 2.76934C18.28 2.05934 20.05 2.26934 21.14 3.34934C22.23 4.42934 22.44 6.20934 21.73 8.32934L18.9 16.8193C17.57 20.7993 15.9 21.6293 14.72 21.6293ZM8.14 7.02934C5.36 7.95934 4.37 9.05934 4.37 9.77934C4.37 10.4993 5.36 11.5993 8.14 12.5193L10.66 13.3593C10.88 13.4293 11.06 13.6093 11.13 13.8293L11.97 16.3493C12.89 19.1293 14 20.1193 14.72 20.1193C15.44 20.1193 16.54 19.1293 17.47 16.3493L20.3 7.85934C20.81 6.31934 20.72 5.05934 20.07 4.40934C19.42 3.75934 18.16 3.67934 16.63 4.18934L8.14 7.02934Z",
    fill: "#00535C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 14.4C10.42 14.4 10.23 14.33 10.08 14.18C9.78999 13.89 9.78999 13.41 10.08 13.12L13.66 9.53C13.95 9.24 14.43 9.24 14.72 9.53C15.01 9.82 15.01 10.3 14.72 10.59L11.14 14.18C11 14.33 10.8 14.4 10.61 14.4Z",
    fill: "#00535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2New);
export default __webpack_public_path__ + "static/media/send-2-new.0c2aade3.svg";
export { ForwardRef as ReactComponent };